<div class="clock-container">
  <div class="clock">
    <div class="segment">
      <span class="digit">{{ hour }}</span>
    </div>
    <div class="separator">:</div>
    <div class="segment">
      <span class="digit">{{ minute }}</span>
    </div>
    <div class="separator">:</div>
    <div class="segment">
      <span class="digit">{{ second }}</span>
    </div>
  </div>
</div>
